/**
 * A type-guard which uses `Object.hasOwn` to ensure the provided `obj` has the
 * provided `key` as an own-property.
 */
export const hasKey = (obj, key) => {
    return Object.hasOwn(obj, key);
};
